import { ContentLoader } from "@/components/ui/loaders";
import { Suspense } from "react";
import { AuthProvider } from "./auth.provider";
import { Helmet, HelmetProvider } from "react-helmet-async";
export function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Fornada</title>
        <meta
          http-equiv="Content-Security-Policy"
          content="default-src * 'unsafe-inline' 'unsafe-eval' data: blob:;"
        />
      </Helmet>
      <AuthProvider>
        <Suspense fallback={<ContentLoader show />}>{children}</Suspense>
      </AuthProvider>
    </HelmetProvider>
  );
}
